import React, { useEffect, useState } from 'react';
import { Link, useLocation } from "react-router-dom";
import WOW from 'wow.js';
import 'animate.css';
import { Navbar, Nav, Container, Offcanvas } from 'react-bootstrap';
import { GrServices } from "react-icons/gr";

const NavBar = () => {
    const location = useLocation();

    useEffect(() => {
        new WOW({ live: false }).init();
    }, []);


    const [modalStateSM, setModalStateSM] = useState(false)
    const [modalState, setModalState] = useState(false)

    const isServiceActive = !["/", "/Who-We-Are", "/Careers", "/contact-us"].includes(location.pathname);

    return (

        <div className='contain-nav'>
            <div className='navLogo' to="/">
                <img src="/logo.png"
                    className="logo d-inline-block align-top img-fluid"
                    data-wow-duration="0.5s"
                    alt="Logo"
                />
            </div>

            <div className='navBar' to="/">
                <Navbar expand="lg" className="custom-navbar">

                    <Navbar.Brand as={Link} to="/">
                        <img src="/logo.png"
                            className="logo logovissibility d-inline-block align-top img-fluid"
                            data-wow-duration="0.5s"
                            alt="Logo"
                        />
                    </Navbar.Brand>

                    <Navbar.Toggle aria-controls="offcanvasNavbar" />
                    <Navbar.Offcanvas
                        id="offcanvasNavbar"
                        aria-labelledby="offcanvasNavbarLabel"
                        placement="end" className="navToggle"
                        scroll={true}>

                        <Offcanvas.Header closeButton>
                            <Offcanvas.Title id="offcanvasNavbarLabel">

                                <img src="/logo.png"
                                    className="logo d-inline-block align-top img-fluid wow fadeInDown"
                                    data-wow-duration="0.5s"
                                    alt="Logo"
                                />
                            </Offcanvas.Title>
                        </Offcanvas.Header>

                        <Offcanvas.Body>
                            <Nav className="me-auto">
                                <Nav.Link as={Link} to="/"
                                    className={`color_black ${location.pathname === "/" ? "activeNav" : ""}`}
                                >
                                    HOME
                                </Nav.Link>
                                <Nav.Link as={Link} to="/Program&Services"
                                    className={`color_black ${location.pathname === "/Program&Services" ? "activeNav" : ""}`}
                                >
                                    PROGRAMS & SERVICES
                                </Nav.Link>
                                <Nav.Link as={Link} to="/Team"
                                    className={`color_black ${location.pathname === "/Team" ? "activeNav" : ""}`}
                                >
                                    OUR TEAM
                                </Nav.Link>
                                <Nav.Link as={Link} to="/About-Us"
                                    className={`color_black ${location.pathname === "/About-Us" ? "activeNav" : ""}`}
                                >
                                    ABOUT
                                </Nav.Link>
                            </Nav>
                            <Nav>
                                <Nav.Link href="https://www.zeffy.com/en-CA/donation-form/donate-to-change-lives-184"
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    className="link-rounded">
                                    Donate Now
                                </Nav.Link>
                            </Nav>
                        </Offcanvas.Body>
                    </Navbar.Offcanvas>
                </Navbar>
            </div>

        </div>
    );
};

export default NavBar;